"use strict";
import angular from "angular";
import custModule from "emun.cust/cust.module";
import custLocationModule from "emun.cust/locations/ship-location.module";
import customerCleanupModule from "emun.customer/cleanup/customer-cleanup.module";
import contactPromptDirective from "emun.customer/contact-prompt-directive";
import customerActivities from "emun.customer/customer-activities";
import customerCampaignActivity from "emun.customer/customer-campaign-activity";
import customerCampaigns from "emun.customer/customer-campaigns";
import customerCategoriesPurchased from "emun.customer/customer-categories-purchased";
import customerContacts from "emun.customer/customer-contacts";
import customerContainer from "emun.customer/customer-container";
import customerCustomFields from "emun.customer/customer-custom-fields";
import customerDashboard from "emun.customer/customer-dashboard";
import customerDashboardHeader from "emun.customer/customer-dashboard-header";
import customerDashboardToolbar from "emun.customer/customer-dashboard-toolbar";
import customerList from "emun.customer/customer-list";
import customerListCards from "emun.customer/customer-list-cards";
import customerListMap from "emun.customer/customer-list-map";
import customerListTable from "emun.customer/customer-list-table";
import customerMap from "emun.customer/customer-map";
import customerNotePromptDirective from "emun.customer/customer-note-directive";
import customerNotes from "emun.customer/customer-notes";
import customerNotesPopup from "emun.customer/customer-notes-popup";
import customerOpenOrders from "emun.customer/customer-open-orders";
import customerProductLists from "emun.customer/customer-product-lists";
import customerProductViews from "emun.customer/customer-product-views";
import customerQuarterlySalesCategory from "emun.customer/customer-quarterly-sales-category";
import customerQuarterlySalesSource from "emun.customer/customer-quarterly-sales-source";
import customerQueryCriteria from "emun.customer/customer-query-criteria";
import customerQuickView from "emun.customer/customer-quick-view";
import customerRecentOrders from "emun.customer/customer-recent-orders";
import customerRecommendedProducts from "emun.customer/customer-recommended-products";
import customerReview from "emun.customer/customer-review";
import customerServiceNotePromptDirective from "emun.customer/customer-service-note-directive";
import customerServiceNotes from "emun.customer/customer-service-notes";
import customerTags from "emun.customer/customer-tags";
import customerVendorDetails from "emun.customer/customer-vendor-details";
import customerVendorInformation from "emun.customer/customer-vendor-information";
import customerVendorPenetration from "emun.customer/customer-vendor-penetration";
import customerVendorsPurchased from "emun.customer/customer-vendors-purchased";
import customerVendorsShipped from "emun.customer/customer-vendors-shipped";
import dealerList from "emun.customer/dealers/dealer-list";
import customerMergeModule from "emun.customer/merge/customer-merge.module";
import badgeScans from "emun.customer/scan-badge/badge-scans";

import { extendModule } from "ng";

const deps = [
  "emun.auth",
  "webutils",
  "webforms",
  "webmodals",
  "emun.retailer",
  "emun.order",
  "emun.invoice",
  "emun.customer",
  "ui.router",
  ...custModule.dependencies,
  ...custLocationModule.dependencies
];

export const app = angular
  .module("emun.customer", deps)
  .component("customerContainer", customerContainer)
  .component("customerList", customerList)
  .component("customerListCards", customerListCards)
  .component("customerListMap", customerListMap)
  .component("customerListTable", customerListTable)
  .component("dealerList", dealerList)
  .component("customerNotes", customerNotes)
  .component("customerServiceNotes", customerServiceNotes)
  .component("customerActivities", customerActivities)
  .component("customerVendorInformation", customerVendorInformation)
  .component("customerDashboard", customerDashboard)
  .component("customerReview", customerReview)
  .component("customerRecentOrders", customerRecentOrders)
  .component("customerProductViews", customerProductViews)
  .component("customerProductLists", customerProductLists)
  .component("customerCustomFields", customerCustomFields)
  .component("customerQuarterlySalesSource", customerQuarterlySalesSource)
  .component("customerQuarterlySalesCategory", customerQuarterlySalesCategory)
  .component("customerContacts", customerContacts)
  .component("customerCampaignActivity", customerCampaignActivity)
  .component("customerCampaigns", customerCampaigns)
  .component("customerDashboardHeader", customerDashboardHeader)
  .component("customerDashboardToolbar", customerDashboardToolbar)
  .component("customerCategoriesPurchased", customerCategoriesPurchased)
  .component("customerVendorsPurchased", customerVendorsPurchased)
  .component("customerVendorPenetration", customerVendorPenetration)
  .component("customerVendorsShipped", customerVendorsShipped)
  .component("customerVendorDetails", customerVendorDetails)
  .directive("contactPrompt", contactPromptDirective)
  .directive("customerNotePrompt", customerNotePromptDirective)
  .directive("customerServiceNotePrompt", customerServiceNotePromptDirective)
  .component("customerNotesPopup", customerNotesPopup)
  .component("customerQuickView", customerQuickView)
  .component("customerQueryCriteria", customerQueryCriteria)
  .component("customerTags", customerTags)
  .component("customerRecommendedProducts", customerRecommendedProducts)
  .component("customerMap", customerMap)
  .component("customerOpenOrders", customerOpenOrders)
  .component("badgeScans", badgeScans);

extendModule(app, custModule);
extendModule(app, custLocationModule);
extendModule(app, customerMergeModule);
extendModule(app, customerCleanupModule);

export default app.name;
